// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  googleMapsApiKey: 'AIzaSyD-W3LpUpNWsD5HpP5VAr83nwgXUgI2j-Y',
  firebaseConfig: {
    apiKey: 'AIzaSyCmQg83_ukzmB_yqcSC9gbiEVY_EVoqHAQ',
    authDomain: 'camino-dev.firebaseapp.com',
    databaseURL: 'https://camino-dev.firebaseio.com',
    projectId: 'camino-dev',
    storageBucket: 'camino-dev.appspot.com',
    messagingSenderId: '444782908485',
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
